import colorConfigs from "../../configs/colorConfigs";

export const introductionPageStyles = {
    rootPaper: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        backgroundColor: colorConfigs.secondary,
    },
    headerBox: {
        position: "sticky",
        top: 0,
        width: "100%",
        backgroundColor: colorConfigs.secondary,
        zIndex: 10,
        py: 2,
        textAlign: "center",
        borderBottom: `2px solid ${colorConfigs.tertiary}`,
    },
    contentBox: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        width: "100%",
        textAlign: "center",
        backgroundColor: colorConfigs.secondary,
    },
};
